/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const RestoreIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6190B7',
  colorSecondary = '#CEDBEA',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      width={37}
      height={36}
      fill="none"
    >
      <path
        fill={color}
        d="M19.994 1.922V0h-1.89v1.922C10.466 2.366 4.26 8.162 3.16 15.627l-1.72-2.03L0 14.824l3.823 4.51 4.585-3.843-1.211-1.454-2.159 1.809c.99-6.52 6.398-11.585 13.066-12.025v1.863h1.89V3.821c7.074.466 12.73 6.138 13.196 13.232h-1.867v1.894h1.867c-.466 7.094-6.122 12.766-13.196 13.232v-1.863h-1.89v1.863c-5.537-.365-10.207-3.919-12.198-8.85l-1.751.71c2.27 5.623 7.616 9.67 13.949 10.039V36h1.89v-1.922c8.118-.472 14.618-6.99 15.09-15.13H37v-1.895h-1.917c-.47-8.14-6.971-14.659-15.09-15.13Z"
      />
      <path
        fill={colorSecondary}
        d="M18.766 9.016a3.874 3.874 0 0 0-3.655 3.873 3.89 3.89 0 0 0 3.825 3.889h-2.27c-.543 0-1.071.093-1.553.279h-.002A4.616 4.616 0 0 0 12 21.442v3.111h6.222v.001H26v-3.11a4.66 4.66 0 0 0-4.666-4.667h-2.27a3.89 3.89 0 0 0 3.732-4.744h-.001A3.887 3.887 0 0 0 18.999 9c-.077 0-.155 0-.233.016Z"
      />
    </svg>
  );
};
